import { ExtraPill, ExtrasList } from "pages/Application/Recommendation/Recommendation.styles"
import React from "react"

interface ExtrasSectionProps {
  offset: boolean
  portable: boolean
  cashback: number
  formattedCashback: string
  freeLegals: boolean
  freeValuation: boolean
}

export const ExtrasSection = ({
  offset,
  portable,
  cashback,
  formattedCashback,
  freeLegals,
  freeValuation,
}: ExtrasSectionProps) => {
  return (
    <>
      <ExtrasList aria-label="Extras">
        {offset && (
          <ExtraPill>
            <span></span>
            <span>Offset</span>
          </ExtraPill>
        )}
        {portable && (
          <ExtraPill>
            <span></span>
            <span>Portable</span>
          </ExtraPill>
        )}
        {(cashback && cashback > 0) === true && (
          <ExtraPill>
            <span></span>
            <span>£{formattedCashback} Cashback</span>
          </ExtraPill>
        )}
        {freeLegals && (
          <ExtraPill>
            <span></span>
            <span>Free standard legal costs*</span>
          </ExtraPill>
        )}
        {freeValuation && (
          <ExtraPill>
            <span></span>
            <span>Free valuation</span>
          </ExtraPill>
        )}
      </ExtrasList>
    </>
  )
}
